import React from "react";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { TVehicle } from "types";

import { Heatmap } from "./components";

import { useSmartNavigate } from "helper/SmartLink";

interface IMaintenance {}
const Maintenance: React.FC<IMaintenance> = () => {
  const navigate = useSmartNavigate();

  const showDetail = (vehicle: TVehicle) => {
    navigate("/catalog/dt/" + vehicle.wgnr);
  };

  return (
    <Box
      sx={{
        display: "grid",
        columnGap: 2,
        rowGap: 2,
        gridTemplateColumns: { lg: "repeat(6, 1fr)" },
      }}
    >
      <Paper
        data-testid="page-maintenance"
        variant="outlined"
        sx={{
          p: 2,
          background: "#FFFFFFDD",
          opacity: 1,
          gridColumn: { lg: "span 3" },
        }}
      >
        <Typography component="h2" variant="h5">
          Heatmap
        </Typography>
        <Heatmap onClickHandler={showDetail} />
      </Paper>
    </Box>
  );
};
export default Maintenance;
